/* Sugerencia en el carrito con regla de negocio, no carrusel generico:
   - solo pelotas              -> personalizacion (manda a la ficha, ahi se captura el texto)
   - pelotas + personalizacion -> gorra (rota entre modelos, se agrega en un clic)
   - gorra sin accesorio       -> marcador (se agrega en un clic)
   Nunca sugiere algo que ya esta en el carrito.

   IMPORTANTE: el bloque va DENTRO de la zona con scroll, despues de los
   articulos, no en el pie. El pie del cajon es fijo y no hace scroll: todo lo
   que se le agregue le quita altura a la lista de productos, y en movil eso
   dejaba los articulos cortados a la mitad. */
(function () {
  var nativeFetch = window.fetch.bind(window);
  var cache = {};
  var busy = false;

  var GORRAS = [
    'legacy-cap-coral',
    'urban-cap',
    'gray-trucker-cap',
    'classic-green-cap',
    'legacy-cap-masters',
    'flagship-cap',
    'legacy-cap-blue-coral',
    'turquoise-trucker-cap',
    'classic-blue-cap',
    'white-trucker-cap',
    'legacy-cap'
  ];

  var NOTES = {
    'legacy-cap-coral': 'Banda antisudor que aguanta los 18 hoyos.',
    'legacy-cap': 'Isotipo bordado y perfil bajo. Va con todo.',
    'legacy-cap-masters': 'Isotipo bordado y perfil bajo. Va con todo.',
    'legacy-cap-blue-coral': 'Isotipo bordado y perfil bajo. Va con todo.',
    'urban-cap': 'La mas ligera del catalogo, con portatees integrado.',
    'gray-trucker-cap': 'Malla atras: ventilacion total para el calor.',
    'white-trucker-cap': 'Malla atras: ventilacion total para el calor.',
    'turquoise-trucker-cap': 'Malla atras: ventilacion total para el calor.',
    'classic-green-cap': 'El nombre Mockingbird al frente, a la vieja escuela.',
    'classic-blue-cap': 'El nombre Mockingbird al frente, a la vieja escuela.',
    'flagship-cap': 'Corte estructurado para los que van en serio.'
  };

  var RULES = {
    perso: { handle: 'personalizacion-pelotas', mode: 'link', eyebrow: 'Hazlas tuyas', note: 'Tus iniciales, nombre o logo impresos en cada pelota.' },
    gorra: { rotate: GORRAS, mode: 'add', eyebrow: 'Completa tu equipo', note: 'Para los 18 hoyos y para despues.' },
    marcador: { handle: 'marcador-para-green-con-clip-para-gorra', mode: 'add', eyebrow: 'El detalle que falta', note: 'Se clipea a la visera y no lo pierdes.' }
  };

  function routeRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function norm(v) { return (v || '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase(); }

  function money(cents) {
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0 }).format(cents / 100);
  }

  function nextIndex(len) {
    var i;
    try {
      i = parseInt(window.localStorage.getItem('mb_sug_gorra') || '0', 10) || 0;
      window.localStorage.setItem('mb_sug_gorra', String((i + 1) % 1000));
    } catch (e) {
      i = Math.floor(Math.random() * len);
    }
    return i % len;
  }

  function decide(cart) {
    var has = { pelotas: false, personalizacion: false, gorras: false, accesorios: false };
    var handles = {};
    (cart.items || []).forEach(function (it) {
      var t = norm(it.product_type);
      if (has.hasOwnProperty(t)) has[t] = true;
      handles[it.handle] = true;
    });

    var key = null;
    if (has.pelotas && !has.personalizacion) key = 'perso';
    else if (has.pelotas && has.personalizacion && !has.gorras) key = 'gorra';
    else if (has.gorras && !has.accesorios) key = 'marcador';
    if (!key) return null;

    var rule = RULES[key];

    if (!rule.rotate) {
      if (handles[rule.handle]) return null;
      return { key: key, handle: rule.handle };
    }

    var list = rule.rotate;
    var start = nextIndex(list.length);
    for (var n = 0; n < list.length; n++) {
      var h = list[(start + n) % list.length];
      if (!handles[h]) return { key: key, handle: h };
    }
    return null;
  }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return nativeFetch(routeRoot() + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function sectionIds() {
    var cd = drawerEl();
    if (cd && typeof cd.getSectionsToRender === 'function') {
      try { return cd.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    return null;
  }

  function verifyOrFallback() {
    setTimeout(function () {
      nativeFetch(routeRoot() + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.item_count) return;
          var rows = document.querySelectorAll('cart-drawer .cart-item, cart-drawer .cart-items tbody tr, .cart-drawer .cart-item');
          if (!rows.length) window.location = routeRoot() + 'cart';
        })
        .catch(function () {});
    }, 700);
  }

  function add(variantId, btn) {
    if (busy) return;
    busy = true;
    var original = btn.textContent;
    btn.textContent = 'Agregando...';
    btn.disabled = true;

    var payload = { items: [{ id: variantId, quantity: 1 }] };
    var ids = sectionIds();
    if (ids) { payload.sections = ids.join(','); payload.sections_url = window.location.pathname; }

    nativeFetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        busy = false;
        btn.disabled = false;
        btn.textContent = original;
        var cd = drawerEl();
        if (cd && json && json.sections && typeof cd.renderContents === 'function') {
          try { cd.renderContents(json); } catch (e) {}
          document.dispatchEvent(new CustomEvent('mb:cart:changed'));
          setTimeout(run, 220);
          verifyOrFallback();
          return;
        }
        window.location.reload();
      })
      .catch(function () { busy = false; btn.disabled = false; btn.textContent = original; window.location.reload(); });
  }

  /* Zona con scroll del cajon. Solo si no existe caemos al pie. */
  function host() {
    return (
      document.querySelector('cart-drawer-items') ||
      document.querySelector('.cart-drawer__form') ||
      document.querySelector('.cart__items') ||
      document.querySelector('.drawer__footer') ||
      document.querySelector('.cart__footer')
    );
  }

  function place(h, el) {
    var isFooter = h.classList && (h.classList.contains('drawer__footer') || h.classList.contains('cart__footer'));
    if (isFooter) {
      h.insertBefore(el, h.firstChild);
    } else {
      h.appendChild(el);
    }
  }

  function paint(pick, product) {
    var h = host();
    if (!h) return;

    var el = document.querySelector('.mb-sug');
    if (el && el.parentNode !== h) { el.parentNode.removeChild(el); el = null; }
    if (!el) {
      el = document.createElement('div');
      el.className = 'mb-sug';
      place(h, el);
    }

    if (!pick || !product) { el.hidden = true; return; }

    var rule = RULES[pick.key];
    var note = NOTES[pick.handle] || rule.note;
    var variant = (product.variants || []).filter(function (v) { return v.available; })[0];
    if (!variant && rule.mode === 'add') { el.hidden = true; return; }

    var img = product.featured_image ? product.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
    var action = rule.mode === 'add'
      ? '<button type="button" class="mb-sug-btn" data-mb-sug-add="' + (variant ? variant.id : '') + '">Agregar</button>'
      : '<a class="mb-sug-btn" href="' + routeRoot() + 'products/' + product.handle + '">Personalizar</a>';

    el.hidden = false;
    el.innerHTML =
      '<p class="mb-sug-eyebrow">' + rule.eyebrow + '</p>' +
      '<div class="mb-sug-row">' +
      (img ? '<img class="mb-sug-img" src="' + img + '" alt="" width="64" height="64" loading="lazy">' : '') +
      '<div class="mb-sug-body">' +
      '<span class="mb-sug-name">' + product.title + '</span>' +
      '<span class="mb-sug-note">' + note + '</span>' +
      '<span class="mb-sug-price">' + money(product.price) + '</span>' +
      '</div>' +
      action +
      '</div>';

    var btn = el.querySelector('[data-mb-sug-add]');
    if (btn) {
      btn.addEventListener('click', function () {
        add(parseInt(btn.getAttribute('data-mb-sug-add'), 10), btn);
      });
    }
  }

  function run() {
    if (!host()) return;
    nativeFetch(routeRoot() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.item_count) { paint(null); return; }
        var pick = decide(cart);
        if (!pick) { paint(null); return; }
        return fetchProduct(pick.handle).then(function (p) { paint(pick, p); });
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('mb:cart:changed', function () { setTimeout(run, 260); });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('cart-drawer, .cart-drawer, #cart-icon-bubble, cart-remove-button, .quantity__button')) {
      setTimeout(run, 480);
    }
  });

  var patched = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    var isCart = href.indexOf('/cart/') !== -1;
    return patched.apply(this, arguments).then(function (res) {
      if (isCart) setTimeout(run, 380);
      return res;
    });
  };

  if (document.readyState !== 'loading') run();
})();
